<template>
    <div :class="getClass">
        {{ formatted.pivot }}
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const getClass = computed(() => {
    if (props.formatted.pivot === 'Active' || props.formatted.pivot === 'N/A') {
        return 'text-unch';
    } else if (props.formatted.pivot === 'Sell') {
        return 'text-down';
    } else if (props.formatted.pivot === 'Buy') {
        return 'text-up';
    }
});
</script>
